// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__QQHI5","question":"styles_question__oHN2G","description":"styles_description__3gEl6"};